import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import Configuration from '../../Services/Api/Configuration'
import DraftsPageContent from '../../components/DraftsPageContent'

const Drafts = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.invoices.drafts.title' })}
           pathname={window.location.origin + NamedRoutes.drafts}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.invoices.drafts.title' })}
      />

      <AccountLayout permission={Configuration.permissions.invoice.view} content={
        <DraftsPageContent entityName={'drafts'}/>
      }/>
    </>
  )
}

export default Drafts
